import { createContext, useContext } from 'react';

export const TreeDataContext = createContext({
    treeData: { menu: [], extra: {}, pathOrder: [] },
    isLoading: false,
    error: null,
});

export function useTreeData() {
    return useContext(TreeDataContext);
}